import birds1 from '../images/birds/QA1A6686.jpg'
import birds2 from '../images/birds/QA1A1682.jpg'
import birds3 from '../images/birds/QE1A4512.jpg'
import birds4 from '../images/birds/QA1A1443.jpg'
import birds5 from '../images/birds/QA1A0284.jpg'
import birds6 from '../images/birds/QA1A5994.jpg'
import birds7 from '../images/birds/QA1A2510.jpg'
import birds8 from '../images/birds/QA1A1416.jpg'
import birds9 from '../images/birds/QA1A4077.jpg'
import birds10 from '../images/birds/QA1A1221.jpg'

export const birdsData = [
  {
    id: 1,
    image: birds1,
    alignment: 'horizontal',
    alt: 'birds image 1 Jari Sokka'
  },
  {
    id: 2,
    image: birds2,
    alignment: 'horizontal',
    alt: 'birds image 2 Jari Sokka'
  },
  {
    id: 3,
    image: birds3,
    alignment: 'horizontal',
    alt: 'birds image 3 Jari Sokka'
  },
  {
    id: 4,
    image: birds4,
    alignment: 'horizontal',
    alt: 'birds image 4 Jari Sokka'
  },
  {
    id: 5,
    image: birds5,
    alignment: 'horizontal',
    alt: 'birds image 5 Jari Sokka'
  },
  {
    id: 6,
    image: birds6,
    alignment: 'horizontal',
    alt: 'birds image 6 Jari Sokka'
  },
  {
    id: 7,
    image: birds7,
    alignment: 'horizontal',
    alt: 'birds image 7 Jari Sokka'
  },
  {
    id: 8,
    image: birds8,
    alignment: 'horizontal',
    alt: 'birds image 8 Jari Sokka'
  },
  {
    id: 9,
    image: birds9,
    alignment: 'horizontal',
    alt: 'birds image 9 Jari Sokka'
  },
  {
    id: 10,
    image: birds10,
    alignment: 'horizontal',
    alt: 'birds image 10 Jari Sokka'
  }
]